/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure and CDN providers — For hosting, content delivery, and performance optimization.`)
};

const es_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores de infraestructura y CDN — Para hospedaje, entrega de contenido y optimización de rendimiento.`)
};

const de_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur- und CDN-Anbieter — Für Hosting, Content-Delivery und Leistungsoptimierung.`)
};

const nl_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructuur- en CDN-providers — Voor hosting, contentlevering en prestatie-optimalisatie.`)
};

const fr_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs d’infrastructure et CDN — Pour l’hébergement, la diffusion de contenu et l’optimisation des performances.`)
};

const it_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitori di infrastruttura e CDN — Per hosting, distribuzione dei contenuti e ottimizzazione delle prestazioni.`)
};

const pt_br2_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores de infraestrutura e CDN — Para hospedagem, entrega de conteúdo e otimização de desempenho.`)
};

const pt_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedores de infraestrutura e CDN — Para alojamento, distribuição de conteúdo e otimização de desempenho.`)
};

const ja_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インフラおよびCDNプロバイダー — ホスティング、コンテンツ配信、パフォーマンス最適化のため。`)
};

const zh_privacy_third_party_infra = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础设施和CDN提供商 — 用于托管、内容分发和性能优化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_third_party_infra = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_third_party_infra(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_third_party_infra", locale)
	if (locale === "en") return en_privacy_third_party_infra(inputs)
	if (locale === "es") return es_privacy_third_party_infra(inputs)
	if (locale === "de") return de_privacy_third_party_infra(inputs)
	if (locale === "nl") return nl_privacy_third_party_infra(inputs)
	if (locale === "fr") return fr_privacy_third_party_infra(inputs)
	if (locale === "it") return it_privacy_third_party_infra(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_third_party_infra(inputs)
	if (locale === "pt") return pt_privacy_third_party_infra(inputs)
	if (locale === "ja") return ja_privacy_third_party_infra(inputs)
	return zh_privacy_third_party_infra(inputs)
};